import ExternalDependenciesConfiguration from "./configurations/ExternalDependenciesConfiguration";

ExternalDependenciesConfiguration.configure();

import '../styleguide/styleguide';
import ReactBoot from '../commons/utils/ReactBoot';
import GroupRequest from './pages/legacyGroupRequest/LegacyGroupRequest';
import JoinGroupRequest from './pages/joinGroupRequest/JoinGroupRequest';
import SearchPage from './pages/search/SearchPage';
import { LandingTabs } from './pages/post/LandingTabs';
// import UnlinkPost from './pages/unlinkPost/UnlinkPost';
import GroupDetailsModal from './pages/groupDetailsModal/GroupDetailsModal';
import { UserModule } from './components/user-module';
import UserHeaderDropdown from '../commons/components/user-header-dropdown/UserHeaderDropdown';
import AddPostButton from '../commons/components/AddPostButton';
import { MywortSearch } from './components';
import PostStore from './stores/PostStore';

PostStore.initialize(window._react_post_list_data, window._react_event_list_data, window._react_locality_list_data, window._react_group_list_data);

ReactBoot.tryBoot(UserModule, "mywort-user-module");
ReactBoot.tryBoot(UserHeaderDropdown, "mywort-header-dropdown");
ReactBoot.tryBoot(AddPostButton, "mywort-header-new-post-action");
ReactBoot.tryBoot(AddPostButton, "mywort-header-new-post-action-float", {style:"float"});
ReactBoot.tryBoot(MywortSearch, "mywort-header-search-mount");
ReactBoot.tryBoot(GroupRequest, "mywort-group-request");
ReactBoot.tryBoot(JoinGroupRequest, "mywort-join-group-panel");
ReactBoot.tryBoot(SearchPage, "mywort-search-page");
ReactBoot.tryBoot(LandingTabs, "mywort-landing-tabs", {activeTab:window._react_active_tab}, true);
// ReactBoot.tryBoot(UnlinkPost, "mywort-unlink-post");    //TODO is it still used?
ReactBoot.tryBoot(GroupDetailsModal, "mywort-group-details-modal");




// WEBPACK FOOTER //
// ./js/mywort/frontend/app.js